import type { Account } from "@onestore/api/account"
import { logoutAccount } from "~/store/account/actions"
import { getAccount } from "~/store/account/selectors"
import { getBasketToken } from "~/store/basket/selectors"
import { useAppDispatch, useAppSelector } from "~/store/hooks"

interface AccountHook {
  account: Account | null
  logout: { (onLogout?: CallableFunction): void }
}

export default function useAccount(): AccountHook {
  const account = useAppSelector(getAccount)
  const token = useAppSelector(getBasketToken)

  const dispatch = useAppDispatch()

  const logout = (onLogout?: CallableFunction) => {
    if (!token) {
      return
    }

    dispatch(logoutAccount(token, onLogout))
  }

  return {
    account,
    logout,
  }
}
